import React from 'react';
import { H3, P } from '@/components/ui/typography';
import { ArrowRight, BookOpenText, SlidersVertical, Sparkles, Youtube } from 'lucide-react';

export const learnBlocks = [
  {
    title: 'What is object audio?',
    description: 'Learn the basics of object audio with an interactive demo.',
    icon: <SlidersVertical />,
    cta: 'Learn about object audio',
    link: '/object-audio-learn',
  },
  {
    title: 'Documentation',
    description: 'Master object audio with the QLab documentation.',
    icon: <BookOpenText />,
    cta: 'Read the documentation',
    link: '/docs/v5/audio/object-audio',
  },
  {
    title: 'Object audio features',
    description: 'Check out what you can do with object audio in QLab.',
    icon: <Sparkles />,
    cta: 'View features',
    link: '/object-audio',
  },
  {
    title: 'Intro video',
    description: 'A short YouTube video introduction to object audio in QLab.',
    icon: <Youtube />,
    cta: 'Watch the video',
    link: 'https://www.youtube.com/watch?v=cRTpqZ_hK0o&ab_channel=Figure53',
    external: true,
  },
];

export const LearnBlock = ({
  icon,
  title,
  description,
  cta,
  link,
  external = false,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  cta: React.ReactNode;
  link: string;
  external?: boolean;
}) => {
  const content = (
    <div className="group hover:scale-105 transition-transform pointer-cursor p-10 bg-background-color/30 flex flex-col justify-between gap-10 rounded-lg h-full">
      <div className="flex flex-col gap-2">
        <div>{icon}</div>
        <H3 className="mt-2">{title}</H3>
        <P className="opacity-80">{description}</P>
      </div>
      <div className="flex gap-1 items-center">
        <div className="underline">{cta}</div>
        <ArrowRight className="group-hover:translate-x-1 transition-transform inline" />
      </div>
    </div>
  );

  if (external) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:no-underline flex-1"
      >
        {content}
      </a>
    );
  }

  return (
    <a href={link} className="no-underline hover:no-underline flex-1">
      {content}
    </a>
  );
};
